import React from 'react';
import { useSearchParams } from 'react-router-dom';
import PrivateRoute from '../components/PrivateRoute';
import Appointments from './Appointments';
import PublicAppointmentRegistration from './PublicAppointmentRegistration';

function AppointmentsRoute() {
  const [searchParams] = useSearchParams();
  const hasPublicRegistrationParams =
    Boolean(searchParams.get('registerVisit')) && Boolean(searchParams.get('token'));

  if (hasPublicRegistrationParams) {
    return <PublicAppointmentRegistration />;
  }

  return (
    <PrivateRoute>
      <Appointments />
    </PrivateRoute>
  );
}

export default AppointmentsRoute;
